export default () => ({
  entity: 'specialization',
  includes: ['type_specialization', 'specialities'],
  entities: 'specializations',
  currentEntity: {},
  specializations: [],
  errors: {
  },
  specialization: {
    attachment: {
      content: null,
      mime: null
    },
    speciality_id: null,
    issuance_date: null,
    type_specialization_id: null,
    area: null,
    entity_name: null,
    start: null,
    end: null
  },
    // never use prefix v1.
  prefixRouter: 'professional.curriculum.specializations'
})



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/resources/data.js